import AuthProviderI18nKeys from "./AuthProvider/AuthProvider.i18n";
import AuthResponseDialogI18nKeys from "./components/AuthResponseDialog/AuthResponseDialog.i18n";
import BaseAuthenticationFormI18nKeys from "./components/BaseAuthenticationForm/BaseAuthenticationForm.i18n";
import AccountHeldErrorI18nKeys from "./components/LoginForm/AccountHeldError/AccountHeldError.i18n";
import LoginFormI18nKeys from "./components/LoginForm/LoginForm.i18n";
import useMfaServicesI18nKeys from "./components/MfaAuthorizer/useMfaServices.i18n";
import MfaContactSelectFormI18nKeys from "./components/MfaContactSelectForm/MfaContactSelectForm.i18n";
import MfaEnterPasscodeFormI18nKeys from "./components/MfaEnterPasscodeForm/MfaEnterPasscodeForm.i18n";
import MfaHeadingI18nKeys from "./components/MfaHeading/MfaHeading.i18n";
import MfaHelpLinkI18nKeys from "./components/MfaHelpLink/MfaHelpLink.i18n";
import MfaProtectedI18nKeys from "./components/MfaProtected/MfaProtected.i18n";
import MfaSuccessI18nKeys from "./components/MfaSuccess/MfaSuccess.i18n";
import MissingCorporateInformationLinkI18nKeys from "./components/MissingCorporateInformationLink/MissingCorporateInformationLink.i18n";
import MissingInformationDialogI18nKeys from "./components/MissingInformationDialog/MissingInformationDialog.i18n";
import MissingInformationFormI18nKeys from "./components/MissingInformationForm/MissingInformationForm.i18n";
import MissingInformationSaveStatusI18n from "./components/MissingInformationSaveStatus/MissingInformationSaveStatus.i18n";
import NewPasswordI18nKeys from "./components/NewPassword/NewPassword.i18n";
import loginSchemaI18nKeys from "./schema/loginSchema.i18n";

export default {
  ...AccountHeldErrorI18nKeys,
  ...AuthResponseDialogI18nKeys,
  ...AuthProviderI18nKeys,
  ...BaseAuthenticationFormI18nKeys,
  ...LoginFormI18nKeys,
  ...MfaContactSelectFormI18nKeys,
  ...MfaEnterPasscodeFormI18nKeys,
  ...MfaHeadingI18nKeys,
  ...MfaHelpLinkI18nKeys,
  ...MfaProtectedI18nKeys,
  ...MfaSuccessI18nKeys,
  ...MissingCorporateInformationLinkI18nKeys,
  ...MissingInformationDialogI18nKeys,
  ...MissingInformationFormI18nKeys,
  ...MissingInformationSaveStatusI18n,
  ...NewPasswordI18nKeys,
  ...loginSchemaI18nKeys,
  ...useMfaServicesI18nKeys,
};
